module.exports = __webpack_public_path__ + "static/RUmobSlide7-e8ff923a82cb87a0452dfabf032a0cd9.jpg";